module.exports = __webpack_public_path__ + "images/arrow.044acbacef5d45bd7a6d47f4988aaa5d.svg";